<template>
    <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
        <a-form-item label="渠道编码">
            <channelSelecter :isForm="true"  :isDisabled="false" @onChannelCodeChange="handleChannelChange"></channelSelecter>
        </a-form-item>
        <a-form-item label="业务分类">
            <messageTypeSelecter :showAll="true" :channelcode="searchP.channelcode" @onmessagestypecodeChange="handleMessagestypecodeChange"></messageTypeSelecter>
        </a-form-item>
        <a-form-item label="设备编号">
            <a-input v-model="searchP.deviceno" placeholder="设备编号" allow-clear></a-input>
        </a-form-item>

        <a-form-item label="消息内容">
            <a-input v-model="searchP.messageecontent" placeholder="消息内容" allow-clear></a-input>
        </a-form-item>

        <a-form-item label="消息ID">
            <a-input v-model="searchP.messagepid" placeholder="消息ID" allow-clear></a-input>
        </a-form-item>

        <a-form-item label="标题">
            <a-input v-model="searchP.messagetitlefuzzy" placeholder="标题" allow-clear></a-input>
        </a-form-item>

        <a-form-item label="状态">
            <a-select  v-model="searchP.status" style="width:100px" placeholder="发送状态" >
                <a-select-option key="">全部</a-select-option>
                <a-select-option key="01">未处理</a-select-option>
                <a-select-option key="00">处理失败</a-select-option>
                <a-select-option key="03">已发送</a-select-option>
                <a-select-option key="04">业务完成</a-select-option>
                <a-select-option key="02">已完结</a-select-option>
            </a-select>
        </a-form-item>

        <a-form-item label="错误信息">
            <a-input v-model="searchP.errormsg" placeholder="错误信息"></a-input>
        </a-form-item>


        <a-form-item label="创建时间">
            <a-range-picker
            :show-time="{
                        hideDisabledOptions: true,
                        format:'HH:mm'
                    }" :format="dateFormat"
            v-model="timeRange"
            @change="onChange" />
        </a-form-item>

        <a-form-item>
            <a-button type="primary" @click="handleSubmit">查询</a-button>
            <a-button type="default" class="ml20"  @click="handleSearchReset">重置</a-button>
        </a-form-item>
    </a-form>
</template>

<script>
import moment from 'moment';
import channelSelecter from '../../components/channelSelecter'
import messageTypeSelecter from '../../components/messageTypeSelecter'


export default {
    components:{
        channelSelecter,
        messageTypeSelecter
    },
    data(){
        return {
            form: this.$form.createForm(this),
            timeRange:undefined,
            dateFormat:"YYYY-MM-DD HH:mm",
            searchP:{
                deviceno:'',
                messageecontent:'',
                messageid:'',
                messagetitle:'',
                status:'',
                starttime:'',
                endtime:'',
                channelcode:'',
                messagestypecode:'',
                errormsg:''
            },
        }
    },

    methods:{
        handleSearchReset(){
            this.searchP = {
                deviceno:'',
                messageecontent:'',
                messageid:'',
                messagetitle:'',
                status:'',
                starttime:'',
                endtime:'',
                channelcode:'',
                messagestypecode:'',
                errormsg:''
            }
            this.getDefaultRange()
            this.handleSubmit()
        },
        handleMessagestypecodeChange(msg){
            this.searchP.messagestypecode = msg.messagestypecode;
            this.handleSubmit()

        },
        handleChannelChange(item){
            this.searchP.channelcode = item.value;
        },
        onChange(){
            //时间跨度不能超过3天
            let starttime =  new Date(this.timeRange[0]).getTime();
            let endtime = new Date(this.timeRange[1]).getTime();
            let timeDiff = endtime - starttime;
            if(timeDiff > (3*24*60*60*1000)){
                this.message.error('时间跨度不能超3天')
                starttime = endtime - (24*60*60*1000*3);
            }
            starttime = new Date(starttime).Format("yyyy-MM-dd hh:mm");
            endtime = new Date(endtime).Format("yyyy-MM-dd hh:mm");
            this.timeRange = [moment(starttime, this.dateFormat), moment(endtime, this.dateFormat)];
            this.searchP.starttime = starttime;
            this.searchP.endtime =endtime
        },
        handleSubmit(){
            this.$emit("handleSearch",this.searchP);
        },
        handleChange(item){
            this.searchP.passwaytype = item.passwaytype;
        },
        getDefaultRange(){
            let now = new Date();
            let query = this.$route.query;
            let sTime = new Date(new Date(now).getTime() - (3*24*60*60*1000) ).Format("yyyy-MM-dd hh:mm");
            let eTime = now.Format("yyyy-MM-dd hh:mm");
            if(query.selectedTimeRange){
                sTime = query.selectedTimeRange.split('~')[0];
                eTime = query.selectedTimeRange.split('~')[1] + ':59';
            }
            this.timeRange = [moment(sTime, this.dateFormat), moment(eTime, this.dateFormat)];
            this.onChange();
        }
    },
    mounted(){
        const {query} = this.$route;
        if(query.messageid){
            this.searchP.messagepid = query.messageid
        }
        if(query.status){
            this.searchP.status = query.status
        }
        this.getDefaultRange()
    }
}

</script>

<style>
    .myform{
        margin-bottom: 20px;
    }
</style>

